export const GET_PRODUCTS = 'products/GET_PRODUCTS'
export const GET_PRODUCTS_SUCCESS = 'products/GET_PRODUCTS_SUCCESS'
export const GET_PRODUCTS_ERROR = 'products/GET_PRODUCTS_ERROR'

export const ORDER_PRODUCTS_SUCCESS = 'products/ORDER_PRODUCTS_SUCCESS'
export const ORDER_PRODUCTS_ERROR = 'products/ORDER_PRODUCTS_ERROR'

export const GET_PAST_VISITS_SUCCESS = 'products/GET_PAST_VISITS_SUCCESS'
export const GET_PAST_VISITS_ERROR = 'products/GET_PAST_VISITS_ERROR'

export const GET_VISIT_SUCCESS = 'products/GET_VISIT_SUCCESS'
export const GET_VISIT_ERROR = 'products/GET_VISIT_ERROR'

export const LOADING_ACTION = 'products/LOADING_ACTION'
export const ERROR_ACTION = 'products/ERROR_ACTION'

export const productsBlackList = [
  GET_PRODUCTS,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_ERROR,
  ORDER_PRODUCTS_SUCCESS,
  ORDER_PRODUCTS_ERROR,
  GET_PAST_VISITS_SUCCESS,
  GET_PAST_VISITS_ERROR,
  LOADING_ACTION,
  GET_VISIT_SUCCESS,
  GET_VISIT_ERROR,
  ERROR_ACTION,
]
